<template>
  <div class="home">
    <div class="adHeightHome">
      <AdBanner :page="wpHome" />
    </div>
    <!-- Post and Widget Section -->
    <div class="container Post_WidgetSection TestNew">
      <template v-if='isMobile(true)'>
        <b-row>
          <b-col sm="12" v-if="tm_params.reports !== '' || title == 'Statistics Tables'">
            <template v-if="currentReport != undefined || currentReport != 'tmoomt'">
              <template v-if="currentReport.includes('tmentry')">
                <NextTournament 
                  :season="this.season"
                  :config="config"
                  :data="data"
                  :Newreport="Newreport"
                  :Year="season"
                  :courseCode="course"
                  :title="title"
                  :currentReport="currentReport"
                  :multi_tourns="multi_tourns"
                  :pastT="pastT"
                  :past_tourns="past_tourns"
                  :head="head"
                  :tm='tm'
                  :tm_params="tm_params"
                  :course="course"
                  :live_scoring="live_scoring"
                  :match="match"
                  :Stableford="Stableford"
                  :reports="reports"
                  :nextRound='nextRound'
                  :roundBtns="roundBtns"
                  :home="homepage"
                  :develop="develop"
                />
              </template>
              <template v-else>
                <UpComing 
                  :data="data"
                  :Newreport="Newreport"
                  :Year="season"
                  :courseCode="course"
                  :title="title"
                  :currentReport="currentReport"
                  :config="config"
                  :multi_tourns="multi_tourns"
                  :pastT="pastT"
                  :past_tourns="past_tourns"
                  :head="head"
                  :tm='tm'
                  :tm_params="tm_params"
                  :course="course"
                  :live_scoring="live_scoring"
                  :match="match"
                  :Stableford="Stableford"
                  :reports="reports"
                  :nextRound='nextRound'
                  :roundBtns="roundBtns"
                />
              </template>
            </template>
            <template v-else>
              <UpComing 
                :data="data"
                :Newreport="Newreport"
                :Year="season"
                :courseCode="course"
                :title="title"
                :currentReport="currentReport"
                :config="config"
                :multi_tourns="multi_tourns"
                :pastT="pastT"
                :past_tourns="past_tourns"
                :head="head"
                :tm='tm'
                :tm_params="tm_params"
                :course="course"
                :live_scoring="live_scoring"
                :match="match"
                :Stableford="Stableford"
                :reports="reports"
                :nextRound='nextRound'
                :roundBtns="roundBtns"
              />
            </template>
          </b-col>
          <b-col sm="12">
            <Slider
              :develop="develop"
              :posts="SliderPost"
              :Year="this.season"
              :config="config"
            />
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <template v-if="tm_params.reports == '' || title == 'Statistics Tables'">
          <b-row>
            <b-col lg='12' sm="12">
              <Slider
                :develop="develop"
                :posts="SliderPost"
                :Year="this.season"
                :config="config"
              />
            </b-col>
          </b-row>
        </template>
        <template v-else>
          <b-row>
            <b-col lg='8' sm="12">
              <Slider
                :develop="develop"
                :posts="SliderPost"
                :Year="this.season"
                :config="config"
              />
            </b-col>
            <b-col lg='4' sm="12">
              <!-- <template v-if="tm_params.days_away < '-7' || tm_params.reports == ''">
                <template v-if="course == 'ISQA' ">
                  <SmallOomRight
                    :develop="develop"
                    :oom="oom"
                    :season="this.season"
                    :home="homepage"
                    :key="componentKey"
                    :config="config"
                  />
                </template>
                <template v-else>
                  <NextTournament 
                    :season="this.season"
                    :config="config"
                    :reports="tm_params.reports"
                  />
                </template>
              </template> -->
              <template>
                <template v-if="currentReport.includes('tmentry')">
                  <NextTournament 
                    :season="this.season"
                    :config="config"
                    :data="data"
                    :Newreport="Newreport"
                    :Year="season"
                    :courseCode="course"
                    :title="title"
                    :currentReport="currentReport"
                    :multi_tourns="multi_tourns"
                    :pastT="pastT"
                    :past_tourns="past_tourns"
                    :head="head"
                    :tm='tm'
                    :tm_params="tm_params"
                    :course="course"
                    :live_scoring="live_scoring"
                    :match="match"
                    :Stableford="Stableford"
                    :reports="reports"
                    :nextRound='nextRound'
                    :roundBtns="roundBtns"
                    :home="homepage"
                    :develop="develop"
                  />
                </template>
                <template v-else>
                  <UpComing 
                    :data="data"
                    :Newreport="Newreport"
                    :Year="season"
                    :courseCode="course"
                    :title="title"
                    :currentReport="currentReport"
                    :config="config"
                    :multi_tourns="multi_tourns"
                    :pastT="pastT"
                    :past_tourns="past_tourns"
                    :head="head"
                    :tm='tm'
                    :tm_params="tm_params"
                    :course="course"
                    :live_scoring="live_scoring"
                    :match="match"
                    :Stableford="Stableford"
                    :reports="reports"
                    :nextRound='nextRound'
                    :roundBtns="roundBtns"
                  />
                </template>
              </template>
            </b-col>
          </b-row>
        </template>
      </template>
    </div>


      <b-container class="nocon" v-if="showbutton && tourSelect.ASN == 'Y'">
        <template>
          <div class="">
            <template v-if="pollsource == 'B' || pollsource == 'W' && pollgeneral == 'Y'">
              <template v-if="pollappImage != ''">
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <img class="appImage pulse" :src="pollappImage">
                  </b-link>
                </template>
                <template v-else>
                  <img class="appImage pulse" v-b-modal.modal-xl :src="pollappImage">
                </template>
              </template>
              <template v-else>
                <template v-if="pollType == 'E'">
                  <b-link @click="pollTypeEclick">
                    <b-button variant="success" class="pulse"> Vote for Player of the Month</b-button>
                  </b-link>
                </template>
                <template v-else>
                  <b-button v-b-modal.modal-xl variant="success" class="pulse"> Vote for Player of the Month</b-button>
                </template>
              </template>
            </template>
          </div>
        </template>
      </b-container>

      <!-- Polls Section to test -->
        <b-modal id="modal-xl" size="xl" hide-footer="true">
          <b-container>
            <div v-for="(box, index) in Extradata" :key="index">
              <template v-if="thankyouMessage == 'N'">
                <div >
                  <b-row>
                    <b-col lg="6" sm="12">
                      <template v-if="box.website_video_url !== ''">
                        <template v-if="box.website_video_auto == 'Y'">
                          <iframe allowfullscreen aspect="16by9" muted playsinline allow='autoplay' :src="box.website_video_url + '&autoplay=1'" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <template v-else>
                          <iframe allowfullscreen aspect="16by9" muted playsinline :src="box.website_video_url" width="100%" height="300" style="border:none;"></iframe>
                        </template>
                        <!-- <b-embed
                          type="iframe"
                          aspect="16by9"
                          :src="box.website_video_url"
                          allowfullscreen
                        ></b-embed> -->
                      </template>
                      <template v-else-if="box.website_image != ''">
                        <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                      </template>
                      <b-modal id="modal-1" title="Terms and Conditions" style="height: 600px; overflow: scroll;">
                        <h3 class="my-4 termsTitle" v-html="docTitle"></h3>
                        <p class="my-4 termsContent" v-html="docContent"></p>
                      </b-modal>
                    </b-col>
                    <b-col lg="6" sm="12">
                      <form class="formSection" ref="formdata">
                        <b-row>
                          <b-col lg="12" sm="12">
                            <p class="boxFull" v-if="box.full_desc != ''" v-html="box.full_desc"></p>
                          </b-col>
                          <!-- <b-col lg="6" sm="12">
                            <p class="boxexpiry" v-if="box.end_date != '' && box.end_time != ''" > Vote expiry date: {{box.end_date}} - {{box.end_time}} ({{timeZone}})</p>
                          </b-col> -->
                        </b-row>
                        <template v-if="box.anonymous == 'N'">
                          <b-row>
                            <b-col lg="5" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polfirstName"
                                  type="name"
                                  placeholder="Enter First Name"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polSurname"
                                  type="name"
                                  placeholder="Enter Surname"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <div class="extraPadTop">
                                <b-form-checkbox
                                  id="checkbox-2"
                                  v-model="terms"
                                  name="checkbox-2"
                                  value="accepted"
                                  unchecked-value="not_accepted"
                                >
                                  I accept the <span class="termsandCon" @click="getTermsConditions" v-b-modal.modal-1>terms and conditions</span>
                                </b-form-checkbox>

                                <!-- <div>State: <strong>{{ terms }}</strong></div> -->
                              </div>
                              <!-- <div class="joinFanzon" v-if="box.askfanzone == 'Y'">
                                <b-form-checkbox
                                  id="checkbox-1"
                                  v-model="fanZonejoin"
                                  name="checkbox-1"
                                  value="Y"
                                  unchecked-value="N"
                                >
                                Join Fanzon
                                </b-form-checkbox>

                              </div> -->
                              <div class="deskHide">
                                <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                                <b-row>
                                  <b-col cols="6" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                    <lable v-if="box.multi_select == 'N'">
                                      <span class="titlesCol">
                                        Select one below
                                      </span>
                                    </lable>
                                    <lable v-else>
                                      <span class="titlesCol">
                                        Select one or more below
                                      </span>
                                    </lable>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showvotes == 'Y'">
                                    <span class="titlesCol votes">
                                      Votes
                                    </span>
                                  </b-col>
                                  <b-col v-if="Extradata[0].showpercent == 'Y'">
                                    <span class="titlesCol perc">
                                      %
                                    </span>
                                  </b-col>
                                </b-row>
                                <b-form-group label="" v-slot="{ ariaDescribedby }">
                                  <b-row>
                                    <template v-if="box.multi_select == 'N'">
                                      <b-col lg="12" sm="12" v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <b-row>
                                          <b-col cols="6" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                              {{op.desc}}
                                            </b-form-radio>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span>{{op.percent}}</span>
                                            </template>
                                          </b-col>
                                        </b-row>
                                      </b-col>
                                    </template>
                                    <template v-else>
                                      <b-col lg="12" sm="12">
                                        <div v-for="(op, index) in box.opts.opts_entry" :key="index">
                                        <b-row>
                                          <b-col :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="op.desc">{{op.desc}}</label>
                                          </b-col>
                                          <b-col v-if="box.showvotes == 'Y'">
                                            <template v-if="box.showvotes == 'Y'">
                                              <span v-if="op.votes !== '0'" class="opt">{{op.votes}}</span>
                                            </template>
                                          </b-col>
                                          <b-col v-if="box.showpercent == 'Y'">
                                            <template v-if="box.showpercent == 'Y'">
                                              <span class="percent">{{op.percent}}</span>
                                            </template>                                            
                                          </b-col>
                                        </b-row>
                                        </div>
                                      </b-col>
                                    </template>
                                  </b-row>
                                </b-form-group>
                              </div>
                              <!-- <div class="mt-3">Selected: <strong>{{ Polselected + 1 }}</strong></div> -->
                              <template v-if="polEmail !== '' && polEmail.includes('@') && polfirstName !== '' && polSurname !== '' && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                            <b-col lg="7" sm="12" class="mobHide">
                              <span style="font-weight:bold; padding-bottom: 10px; display:block">{{Extradata[0].question}}</span>
                              <b-row>
                                <b-col lg="8" :class="{nameWidth : Extradata[0].showvotes == 'N' && Extradata[0].showpercent == 'N', nameWidth : Extradata[0].showvotes == 'N' || Extradata[0].showpercent == 'N'}">
                                  <lable v-if="box.multi_select == 'N'">
                                    <span class="titlesCol">
                                      Select one below
                                    </span>
                                  </lable>
                                  <lable v-else>
                                    <span class="titlesCol">
                                      Select one or more below
                                    </span>
                                  </lable>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showvotes == 'Y'">
                                  <span class="titlesCol votes">
                                    Votes
                                  </span>
                                </b-col>
                                <b-col lg="2" v-if="Extradata[0].showpercent == 'Y'">
                                  <span class="titlesCol perc">
                                    %
                                  </span>
                                </b-col>
                              </b-row>
                              <b-form-group label="" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </template>
                        <template v-else>
                          <b-row>
                            <b-col lg="12" sm="12">
                              <b-form-group
                                id="input-group-1"
                                label-for="input-1"
                              >
                                <b-form-input
                                  id="input-1"
                                  v-model="polEmail"
                                  type="email"
                                  placeholder="Enter Email"
                                  required
                                ></b-form-input>
                              </b-form-group>
                              <b-form-group label="Select one below" v-slot="{ ariaDescribedby }">
                                <b-row>
                                  <template v-if="box.multi_select == 'N'">
                                    <b-col lg="12" sm="12" v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N', nameWidth : box.showvotes == 'N' || box.showpercent == 'N'}">
                                          <b-form-radio v-model="Polselected" :aria-describedby="ariaDescribedby" name="some-radios" :value="index">
                                            {{opts.desc}}
                                          </b-form-radio>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                  <template v-else>
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="8" :class="{nameWidth : box.showvotes == 'N' && box.showpercent == 'N'}">
                                          <div v-for="(opts, index) in box.opts.opts_entry" :key="index">
                                            <input type="checkbox" :value="index + 1" v-model="MultiPolselected">
                                            <label class="multiLable" :for="opts.desc">{{opts.desc}}</label>
                                          </div>
                                        </b-col>
                                        <b-col lg="2" v-if="box.showvotes == 'Y'">
                                          <template v-if="box.showvotes == 'Y'">
                                            <span v-if="opts.votes !== '0'" class="">{{opts.votes}}</span>
                                          </template>
                                        </b-col>
                                        <b-col lg="2"  v-if="box.showpercent == 'Y'">
                                          <template v-if="box.showpercent == 'Y'">
                                            <span class="">{{opts.percent}}</span>
                                          </template>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                  </template>
                                </b-row>
                              </b-form-group>
                              <template v-if="polEmail !== '' && polEmail.includes('@') && terms == 'accepted'">
                                <b-button type="button" class="buttonVote" variant="primary" @click="sendPollsData">Submit Vote</b-button>
                              </template>
                              <template v-else>
                                <b-button disabled class="buttonVote des">Submit Vote</b-button>
                              </template>
                            </b-col>
                          </b-row>
                        </template>
                      </form>
                    </b-col>
                  </b-row>
                </div>
              </template>
              <template v-else>
                <b-row>
                  <b-col lg="6" sm="12">
                    <img v-if="box.website_image != ''" class="votePicture" :src="box.website_image">
                  </b-col>
                  <b-col lg="6" sm="12">
                    <template v-if="voteData.status == 'FAIL'">
                      <h2 class="thankyou" v-html="voteData.message"></h2>
                    </template>
                    <template v-else>
                      <h2 class="thankyou">Thank you for your Vote</h2>
                    </template>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-container>
        </b-modal>

      <!-- End of Polls Section to test -->   

      <!-- Q-School Banner Section -->
      <!-- <div v-if="qschoolData.qschool == true">
        <b-container class="containerQ">
          <b-link :href="qschoolData.qschool_banner_url">
            <img class="qschoolBannerImg" :src="qschoolData.qschool_banner">
          </b-link>
        </b-container>
      </div> -->


    <!-- Test Social Wall -->
    <!-- <div v-html="Wpcontent"></div> -->
    <!-- <iframe :src="'https://wp-asiantour.ocs-sport.com/wp-content/themes/asian-tour/socials/socialShowTest.php?version=' + new Date().getTime()"></iframe> -->

    <!-- <div class="socialWall container">
      <div v-html="phpData"></div>
    </div> -->


    <!-- Latest News Section -->

    <div id="feature" class="mobileMarginFeatured">
      <h2 class="SectionTitle container hidelatestNews">Latest News</h2>
      <Post :posts="posts" :develop="develop" :config="config" />
      <b-button class="homeButton NewsBTN" to="/news">See All News</b-button>
    </div>


    <!-- Featured News Section -->
    <div class="featuredNews-Section" style="">
      <h2 class="SectionTitle container hidelatestNews">Featured Articles</h2>
      <FeaturedNews :posts="featured" :develop="develop" :config="config" :featuredTrue="featuredTrue" />
    </div>

    <!-- Review Section -->
    <div class="reviewSection container"> 
      <b-row class="reviewBlock">
        <b-col col lg="6" sm="12" class="firstReview">
          <b-link :href="homeData.acf.left_review_url" target="_blank">
              <!-- <img class="imageReview" :src="homeData.acf.left_review_image" v-b-modal.modal-prevent-closing> -->
              <img class="imageReview" :src="homeData.acf.left_review_image">
          </b-link>
        </b-col>
        <b-col col lg="6" sm="12">
          <b-link :href="homeData.acf.right_review_url" target="_blank">
              <img class="imageReview" :src="homeData.acf.right_review_image">
          </b-link>
        </b-col>
      </b-row>
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        title="Submit Your Details"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
      >
        <div >
          <div class="cmApp_signupContainer  cmApp_embedded" id="cmApp_signupContainer" style="">
                      <div class="cmApp_signupFormWrapper">
                              <input type="hidden" id="cmApp_formType" value="embedded">
                  
                  <div id="cmApp_statusContainer" class="cmApp_statusContainer cmApp_hidden">
                      <div id="cmApp_thankYouCheck">
                          <img src="https://wp-asiantour.ocs-sport.com/wp-content/plugins/forms-for-campaign-monitor/forms/views/public/images/success-icon.svg" alt="">
                      </div>
                      <div class="cmApp_processingMsg">Processing...</div>
                      <div class="cmApp_successMsg">
                          <span>Thank you!</span>
                          <span>Your subscription has been confirmed.</span>
                          <span>You'll hear from us soon.</span>
                      </div>
                  </div>


                  <form action="https://wp-asiantour.ocs-sport.com/wp-admin/admin-post.php" method="post" id="cmApp_signupForm" data-uuid="cm_680f4b5d3b0b3" class="cmApp_cf cm-form-handler ng-pristine ng-valid">

                      <input type="hidden" name="action" value="ajax_handler_nopriv_cm_forms">
                      <input type="hidden" name="no_js" value="1">
                      
                      <div class="cmApp_errorMsg" id="cmApp_errorAll"></div>

                      <input type="hidden" name="formId" id="cmApp_FormId" value="cm_680f4b5d3b0b3">
                      <input type="hidden" name="abTestId" id="cmApp_AbTestId" value="">


                                      <div class="cmApp_fieldWrap">
                                                  <div class="cmApp_formInput"><label>Name</label><input type="text" name="name" id="cmApp_signupName" value="" placeholder=""></div>                    <div class="cmApp_errorMsg" id="cmApp_emailError">ErrorHere</div>
                                              <div class="cmApp_formInput"><label>Email *</label><input type="text" name="email" id="cmApp_signupEmail" value="" placeholder=""></div>
                                                              </div>
                  
                                      <div style="height:2px;"></div>

                      
                      <div>
                          <input type="submit" name="submit" value="SUBSCRIBE" class="cmApp_formSubmitButton post-ajax" style="background-color:#429BD0; color:#FFFFFF;" data-submit="">
                      </div>

                                          <div class="cmApp_logo"><img src="https://wp-asiantour.ocs-sport.com/wp-content/plugins/forms-for-campaign-monitor/forms/views/public/images/PowerdByCampMon@2x.png" style="width:180px;" alt="Powered By Campaign Monitor"></div>
                                  </form>
              </div>
          </div>
        </div>
        <!-- <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
            label="Name"
            label-for="name-input"
            invalid-feedback="Name is required"
            :state="nameState"
          >
            <b-form-input
              id="name-input"
              v-model="name"
              :state="nameState"
              required
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="Email"
            label-for="email-input"
            invalid-feedback="Email is required"
            :state="emailState"
          >
            <b-form-input
              id="email-input"
              v-model="email"
              :state="emailState"
              required
            ></b-form-input>
          </b-form-group>
        </form> -->
      </b-modal>
    </div>

    <!-- Gallery Section -->

    <div class=" GreyBack">
      <!-- <h2 class="SectionTitle container">Latest Images</h2> -->
      <template v-if="homeData.acf.show_tournament_slider == true ">
        <Gallery
          :Tourncode="course"
          :TournName="head"
          :develop="develop"
          :Year="this.season"
        />
      </template>
      <template v-else>
        <WinnerSlider
          :gallery_title="gallery_title"
        />
      </template>
    </div>


    <!-- Featured Content Section -->

    <!-- <div id="feature" class="mobileMarginFeatured featuredContact">
      <h2 class="SectionTitle container">Featured Content</h2>
      <Post :posts="featured" :develop="develop" :config="config" :featuredTrue="featuredTrue" />
    </div> -->

    <!-- OOM Section -->

    <div class="OOMSection mobileMargin oomMobileMargin">
        <SmallOom
          :develop="develop"
          :oom="oom"
          :season="this.season"
          :home="homepage"
          :key="componentKey"
          :config="config"
        />
      <b-button class="homeButton" :to="{
                        name: 'stats',
                        query: {
                          id: this.season,
                          oom:'Y'
                        },
                      }"
      
      >See Full Order of Merit</b-button>
    </div>

    <!-- Video Section -->

    <div class="VideoSection container">
      <h2 class="SectionTitle">Latest Videos</h2>
      <b-row>
        <b-col lg='8' sm="12">
          <div v-html="homeData.acf.video_left"></div>
          <p class="youtubeTitle" v-html="homeData.acf.video_title"></p>
        </b-col>
        <b-col lg='4' sm="12">
          <b-link v-bind:href="homeData.acf.youtube_image_url_right" target="_blank">
            <template v-if='isMobile(true)'>
            <img class="YoutubeLink" src="https://assets.asiantour.com/asian-tour/2024/05/YouTube_Mobile.png">
            </template>
            <template v-else>
              <img class="YoutubeLink" :src="homeData.acf.youtube_image_right">
            </template>
          </b-link>
        </b-col>
      </b-row>
      <b-button class="homeButton" to="/video">See All Videos</b-button>
    </div>

    <!-- Destinations Section -->
    <div class="distinationsSection">
      <div class="Greengrad"></div>
      <template v-if='isMobile(true)'>
        <b-card
          :img-src="homeData.acf.destinations_image"
          img-alt="Image"
          img-top
          tag="article"
          class="DistCard mobileDistCard"
        >
          <b-card-text>
            <div class="cardPad mobileCardPad">
              <h2 class="distTitle" v-html="homeData.acf.destinations_title"></h2>
              <p class="distPara" v-html="homeData.acf.destinations_description"></p>
              <b-button class="distButton" to="/destinations">Discover Destinations</b-button>
            </div>
          </b-card-text>
        </b-card>
      </template>
      <template v-else>
        <b-card :img-src="homeData.acf.destinations_image" img-alt="Card image" img-left class="DistCard">
          <b-card-text>
            <div class="cardPad">
              <h2 class="distTitle" v-html="homeData.acf.destinations_title"></h2>
              <p class="distPara" v-html="homeData.acf.destinations_description"></p>
              <b-button class="distButton" to="/destinations">Discover Destinations</b-button>
            </div>
          </b-card-text>
        </b-card>
      </template>
    </div>

    <!-- Social Wall Section -->

    <div class="socialwall">
      <!-- <div v-html="homeData.acf.social_wall_block"></div> -->

      <!-- <iframe src="https://wp-asiantour.ocs-sport.com/wp-content/themes/asian-tour/templates/socialwall.html"></iframe> -->
      <!-- <iframe src="https://wp-asiantour.ocs-sport.com/wp-content/themes/asian-tour/templates/spon.php"></iframe> -->
    </div>
    <!-- <div id="sponsors">
      <div class="gradSponsor"></div>
      <Sponsors :sponsor="sponsor" :develop="develop" />
    </div> -->
  </div>
</template>
<script type="text/javascript" src="https://wp-asiantour.ocs-sport.com/wp-content/plugins/forms-for-campaign-monitor/forms/views/public/js/app.js?ver=6.7.2" id="forms-for-campaign-monitor-ajax-script-public-js"></script>
<script>
import axios from "axios"
import AdBanner from "@/components/adBanner.vue";
import Slider from "@/components/slider.vue";
// import MiniLeaderboard from "@/components/miniLeaderboard.vue"
import UpComing from "@/components/upcoming.vue";
// import UpComingTest from "@/components/upcomingTest.vue";
import NextTournament from "@/components/nextTournament.vue";
import SmallOom from "@/components/smallOom.vue";
// import SmallOomRight from "@/components/oomRightSlider.vue";
// import Video from "@/components/videoHome.vue";
import Gallery from "@/components/galleryHome.vue";
import WinnerSlider from "@/components/winnerslider.vue";
// import Sponsors from "@/components/sponsors.vue";
import Post from "@/components/posts.vue";
import FeaturedNews from "@/components/featuredPosts.vue";
import apiCall from "@/services/api.js";
import * as CryptoJS from 'crypto-js';
export default {
  name: "home",
  props: ["develop", "season", "oom", "config", "currentReport", "title"],
  components: {
    AdBanner,
    Slider,
    UpComing,
    NextTournament,
    WinnerSlider,
    FeaturedNews,
    // SmallOomRight,
    // UpComingTest,
    // MiniLeaderboard,
    SmallOom,
    // Video,
    Post,
    Gallery,
    // Sponsors,
  }, // Everything below on every /view/<Page Name>.vue for meta info and all ACF data
  data: function() {
    const CryptoJSAesJson = {
      'stringify': (cipherParams) => {
        const j = {ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64)};

        if (cipherParams.iv)
          j.iv = cipherParams.iv.toString();

        if (cipherParams.salt)
          j.s = cipherParams.salt.toString();

        return JSON.stringify(j);
      },
      'parse': (jsonStr) => {
        const j = JSON.parse(jsonStr);
        const cipherParams = CryptoJS.lib.CipherParams.create({ciphertext: CryptoJS.enc.Base64.parse(j.ct)});

        if (j.iv)
          cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);

        if (j.s)
          cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);

        return cipherParams;
      },
    };
    return {
      data:[],
      description: [], //Meta Description
      homepage: true,
      homeData: [],
      wpHome:
        this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/pages/21?_embed&randomadd=" + new Date().getTime(),
      SliderPost: this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/posts?categories=1",
      posts: this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/posts?_embed?per_page=10" + "&randomadd=" + new Date().getTime(),
      featured: this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/posts?categories=12",
      sponsor: this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/",
      dest:
        this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/posts?categories=77",
      componentKey: 0,
      tm_params: [],
      reports: [],
      course: [],
      pastT: [],
      DEFIMAGESAMS3: [],
      live_scoring: '',
      Newreport: '',
      match: '',
      Stableford: '',
      featuredTrue: 'Y',
      nextRound: '',
      roundBtns:[],
      gallery_title: '',
      pollData:[],
      polEmail: '',
      polfirstName: '',
      polSurname:'',
      Polselected: '',
      selectedPol:[],
      MultiPolselected: [],
      showbutton: '',
      timeZone: '',
      selectedItems: [],
      showbuttonExtra: [],
      appImage: '',
      // fanZonejoin: 'Y',
      thankyouMessage: 'N',
      voteData: {},
      terms: '',
      docTitle: '',
      docContent:'',
      pollsource: '',
      pollgeneral: '',
      pollMselect: '',
      pollappImage: '',
      pollType: '',
      pollTypeLink: '',
      Extradata: [],
      tourSelect: '',
      qschoolData: [],
      Wpcontent:'',
      // phpData:''
    };
  },
  computed: {
    // currentReport() {
    //   if (Array.isArray(this.reports))
    //     if (this.reports[this.reports.length - 1].report_title === 'Live Scoring Monitor' || this.reports[this.reports.length - 1].report_title === 'Course Statistics' || this.reports[this.reports.length - 1].report_title === 'Course Statistics (SF)' || this.reports[this.reports.length - 1].report_title === 'Course Statistics (LV)'|| this.reports[this.reports.length - 1].report_title === 'Scoring Statistics' || this.reports[this.reports.length - 1].report_title === 'Statistics Tables') {
    //       if (this.tm_params.rounds_played === '1') {
    //         return this.reports[this.reports.length - 5].report_url;
    //       } else {
    //        console.log('Line 284')
    //        if (this.reports[this.reports.length - 1].report_title === 'Course Statistics' || this.reports[this.reports.length - 1].report_title === 'Course Statistics (LV)' || this.reports[this.reports.length - 1].report_title === 'Course Statistics (SF)') {
    //           return this.reports[this.reports.length - 5].report_url; 
    //        } else {
    //           return this.reports[this.reports.length - 1].report_url; 
    //        }
    //       }
    //     } else {
    //       console.log('Line  288')
    //       return this.reports[this.reports.length - 1].report_url;
    //     }
    //     else return this.reports.report_url;
    // },
    // currentReport: function() {
    //   if (Array.isArray(this.reports))
    //     if (this.reports[this.reports.length - 1].report_title === 'Live Scoring Monitor' || this.reports[this.reports.length - 1].report_title === 'Course Statistics' || this.reports[this.reports.length - 1].report_title === 'Scoring Statistics' || this.reports[this.reports.length - 1].report_title === 'Statistics Tables') {
    //       if (this.tm_params.rounds_played === '1') {
    //         return this.reports[this.reports.length - 5].report_url;
    //       } else {
    //         return this.reports[this.reports.length - 4].report_url; 
    //       }
    //     } else {
    //       return this.reports[this.reports.length - 1].report_url;
    //     }
    //   else return this.reports.report_url;
    // },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_APIFULL_URL +
          this.tm_params.tm_params.season_code +
          "/" +
          this.tm_params.tm_params.season_code +
          "-" +
          this.course +
          "-entryW-entries.json?randomadd=" +
          new Date().getTime();
      } else if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_APIFULL_URL +
          this.tm_params.tm_params.season_code +
          "/" +
          this.tm_params.tm_params.season_code +
          "-" +
          this.course +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscores") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );

          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              this.config.VUE_APP_APIFULL_URL +
              this.tm_params.tm_params.season_code +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
            // var url = "https://dev-auspga.ocs-software.com/api/" + "dev" + "/cache/" + "dev" + "/" + "215S" + "/" + "215S" + "-" + "AUS7" + "-scores-" + $scope.repParams + ".json"+"?randomadd=1603894106415";
          } else {
            url =
              this.config.VUE_APP_APIFULL_URL +
              this.tm_params.tm_params.season_code +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "https://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1 ) {
          {
            url =
              this.config.VUE_APP_APIFULL_URL +
              this.tm_params.tm_params.season_code +
              "/" +
              this.season +
              "-" +
              this.course +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
            // var url = "https://dev-auspga.ocs-software.com/api/dev/cache/dev/215S/215S-AUS7-scores-latest.json?gt=y&randomadd=1573131881374"
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_APIFULL_URL +
            this.tm_params.tm_params.season_code +
            "/" +
            this.season +
            "-" +
            this.course +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          // console.log("resNum === ");
          // console.log(resNum1);
          url =
            this.config.VUE_APP_APIFULL_URL +
            this.tm_params.tm_params.season_code +
            "/" +
            this.season +
            "-" +
            this.course +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            this.config.VUE_APP_APIFULL_URL +
            this.tm_params.tm_params.season_code +
            "/" +
            this.season +
            "-" +
            this.course +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
  },
  methods: {
    // phpTest() {
    //     axios
    //       .get("https://wp-asiantour.ocs-sport.com/wp-content/themes/asian-tour/socials/socialShowTest.php?version='" + new Date().getTime(), {
    //       // .get("https://wp-asiantour.ocs-sport.com/wp-content/themes/asian-tour/socials/socialTwo.php?version='" + new Date().getTime(), {
    //       })
    //       .then(response => {
    //         console.log("php response");
    //         console.log(response);
    //         this.phpData = response.data;
    //       })
    //       .catch(error => {
    //         console.log("php error");
    //         console.log(error);
    //       });

    // },
    getPolls() {
      axios
        .get(
          process.env.VUE_APP_APIFULL_URL +
            "tmticx?randomaddText=" +
            new Date().getTime()
        )
        .then(response => {
          this.Extradata = response.data;
          this.pollData = response.data.tm_params.polls;
          if (this.pollData != '') {
            this.showbutton = 'Y'
            if (Array.isArray(response.data.tm_params.polls.polls_entry)) {
              this.Extradata = response.data.tm_params.polls.polls_entry
            } else {
              console.log("is not Array");
              this.Extradata = [response.data.tm_params.polls.polls_entry];
            }
            // let arr = [];
            // console.log("this.arr")
            // console.log(arr)
            // this.Extradata.forEach((value, index) => {
            //     arr.push(value);
            //     console.log(value.source);
            //     console.log(index);
            // });
            this.pollsource = this.pollData.polls_entry.source;
            this.pollgeneral = this.pollData.polls_entry.general;
            this.pollMselect = this.pollData.polls_entry.multi_select;
            this.pollappImage = this.pollData.polls_entry.app_image;
            this.pollType = this.pollData.polls_entry.type;
            this.pollTypeLink = this.pollData.polls_entry.link_url;
            this.tourSelect = this.pollData.polls_entry.tours.tours_entry[1];
            console.log("this.tourSelect")
            console.log(this.tourSelect)
          } else {
            this.showbutton = 'N'
          }
        })
    },
    // Submiting Data for Polls when Anonymous is set to N
    sendPolls() {
      console.log('IN Send Polls')
      // MultiPolselected
      let voteCode = [];
      this.Extradata.forEach((value) => {
          voteCode.push(value.code);
      });
      this.voteCode = voteCode;
      this.selectedPol = this.Polselected + 1;
      let multiSeleted = []
      console.log("multiSeleted")
      console.log(multiSeleted)
      this.selectMulti = multiSeleted;

      this.MultiPolselected.forEach((value) => {
          multiSeleted.push(value);
      });

      if (this.pollMselect == 'Y') {
        console.log('MultiSelect')
				let sendpolls = '';

				sendpolls += 'apga' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				for (const i of this.selectMulti) {
					sendpolls += 'option_' + (i) + '|~' + 'Y<!/D>';
        }
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        // let sendpolls = "let " + this.polEmail + " . W 'fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + this.leg  + "|~Y<!/D>'"
        return sendpolls 
      } else if(this.pollType == 'E') {
        console.log('Poll Type == E')
        let sendpolls = '';
        sendpolls += 'apga' + ' ';
        sendpolls += '.'  + ' ';
        sendpolls += '. W ';
        sendpolls += "'";
        sendpolls += "code|~" + this.voteCode + "<!/D>";
        sendpolls += 'option_1' + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      } else {
        console.log('NON MultiSelect')
        // let sendpolls = "let " + this.polEmail + '. W' + "'" + "fname|~" + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>" + "option_" + this.selectedPol + "|~Y<!/D>" + "fz|~" + this.fanZonejoin + "<!/D>" + "'"
        let sendpolls = '';

				sendpolls += 'apga' + ' ';
				sendpolls += this.polEmail  + ' ';
				sendpolls += '. W ';
        sendpolls += "'";
				sendpolls += 'fname|~' + this.polfirstName + "<!/D>" + "surname|~" + this.polSurname + "<!/D>" + "code|~" + this.voteCode + "<!/D>"
				sendpolls += 'option_' + this.selectedPol + '|~' + 'Y<!/D>';
        // sendpolls += "fz|~" + this.fanZonejoin + "<!/D>";
        sendpolls += "'";
        return sendpolls
      }
		}, 
    pollTypeEclick() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      console.log('Send Poll Data -- E')
      this.$socket.emit('vote', sktMsg);
      window.open(this.pollTypeLink, '_blank');
    },
    sendPollsData() {
      let sktMsg = this.sendPolls()
      console.log("sktMsg")
      console.log(sktMsg)
      // this.$socket.emit('vote', sktMsg);
      this.$socket.emit('vote', sktMsg, (data) => {
        const jsonDoc = JSON.parse(data);
        this.voteData = jsonDoc;
        console.log("data")
        console.log(data)
      });
      this.thankyouMessage = 'Y' 
    },
    getTermsConditions: function() {
      axios
        .get(
          "https://ocs-asian.com/apps/marketing-terms.php?action=latest&tour=" + 'apga' + "&?randomadd=" +
            new Date().getTime()
        )
        .then((response) => {
          // this.showTerms = 'Y';
          // console.log("this.showTerms")
          // console.log(this.showTerms)
          this.docTitle = this.base64Decode(response.data.documents.document.title);
          console.log("this.docTitle")
          console.log(this.docTitle)
          this.docContent = this.base64Decode(response.data.documents.document.content);
          console.log("this.docContent")
          console.log(this.docContent)
        });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    isMobile() {
      if( screen.width <= 990 ) {
        return true;
      }
      else {
        return false;
      }
    },
    showReport: function() {
      apiCall
      .report(this.reportTitle)
      .then(response => {
        this.Newreport = this.reportTitle
        this.data = response.data;
        this.nextRound = response.data.round;
        this.loading = false;
      })
    },
    updateStuff: function() {
      // console.log('update every 30 seconds')
      apiCall
        .report(this.reportTitle)
        .then(({ data }) => {
          this.data = data;
          this.nextRound = data.round;

          // this.showReport();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
			getLatestDraw(data) {
				const reportsList = this.reports;

				let currDrawRnd = 0;
				// let roundCount = 0;
				let lastRnd = 0;

				this.roundBtns = [];

				for (const i of reportsList) {
					let rndNo = 1;

					if (i.report_title.includes('Draw')) {
						if (i.report_title.includes(' '))
							rndNo = parseInt(i.report_title.split(' ')[1]);

						this.roundBtns.push({'label': 'Rnd ' + rndNo, 'round': rndNo});
						lastRnd = rndNo;
					}
				}

				for (let r = 1; r <= 16; r++) {
					const rndStatus = data['ts_round_status_' + r];

					// if (rndStatus.length) {
						// roundCount++;

						if (rndStatus != 'C' && rndStatus != 'S') {
							for (const i of reportsList) {
								if (i.report_title.includes('Draw') && i.report_title.includes('Round ' + r))
									currDrawRnd = r;
							}

							break;
						}
					// }
				}

				if (currDrawRnd == 0)
					currDrawRnd = lastRnd;
					// currDrawRnd = roundCount;

				this.currRound = currDrawRnd;
      }
  },
  mounted() {
    this.getPolls();
    // this.phpTest();
    axios
      .get(this.config.VUE_APP_WP_ASIAN_TOUR_API_URL + "wp/v2/pages/21?_embed&randomadd=" + new Date().getTime())
      .then(response => {
        this.homeData = response.data;
        this.gallery_title = response.data.acf.gallery_title;
        this.qschoolData = response.data.acf;
        this.Wpcontent = response.data.content.rendered;
        this.showReport();
        this.getLatestDraw();
        this.roundButtons();
        this.loading = true;
      });
  },
  created() {
    apiCall 
      .tmParamsBase()
      .then(({ data }) => {
        this.DEFIMAGESAMS3 = data.tm_params.DEFIMAGESAMS3;
        // console.log( "this.DEFIMAGESAMS3 428" )
        // console.log( this.DEFIMAGESAMS3 )
        this.tm_params = data;
        this.match = data.match_play;
        this.Stableford = data.stableford;
        this.live_scoring = data.live_scoring;
        this.multi_tourns = data.multi_tourns;
        if (this.multi_tourns == 'Y') {
         this.pastT = data.past_tourns.past_tourns_entry.code; 
        }
        if (Array.isArray(data.past_tourns.past_tourns_entry)) {
          // console.log("isArray");
          this.past_tourns = data.past_tourns.past_tourns_entry;
        } else {
          // console.log("is not Array");
          this.past_tourns = [data.past_tourns.past_tourns_entry];
        }
        this.tm = data;
        this.head = data.full_name;
        this.course = data.code;
        this.okfound = data.ok_found;
        this.reports = data.reports.reports_entry;
        this.season = data.tm_params.season_code;
        this.course = data.code;
        this.loading = false;
        // this.showReport();
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
      setInterval(this.updateStuff, 120000);
  },
};
</script>
<style scoped>
.featuredNews-Section {
  margin-bottom: 80px;
}
img.qschoolBannerImg {
    width: 100%;
}
.containerQ.container {
  padding-top: 30px;
  padding-bottom: 60px;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  50% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }

  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
div#modal-1___BV_modal_content_ {
    height: 600px;
    overflow: scroll;
}
span.termsandCon {
  text-decoration: underline;
}
h2.thankyou {
  color: #00477c;
  text-align: center;
  margin-top: 120px;
}
.extraPadTop {
  padding-top: 30px;
}
.opt {
  position: absolute;
  right: 0;
  top: 0;
}
.multiLable {
  padding-left: 15px;
}
.appImage {
  width: 300px;
  position: absolute;
  right: 12em;
  margin-top: 18px;
}
.appImageLeft {
  width: 300px;
  position: absolute;
  left: 11em;
  margin-top: 18px;
}
::v-deep header#modal-xl___BV_modal_header_ {
  display: none!important;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: none!important;
}
.pulse {
  animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(82, 255, 131, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
}
button.btn.btn-success {
  /* position: absolute; */
  right: 14em;
  margin-top: 0px;
  width: 100%;
  height: 50px;
  margin-bottom: 90px;
  background-color: #002377;
  border-color: #002377;
}
button.btn.buttonVote.des.btn-secondary.disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  cursor: not-allowed;
}
p.boxFull {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 0px;
}
.boxexpiry {
  color: #01477b;
  font-size: 12pt;
  padding-bottom: 30px;
}
.formSection {
  padding-top: 30px;
  background: white;
  padding: 40px;
  font-size: 13pt;
  color: #00477c;
  padding-top: 0px;
}
.votePicture {
  width: 100%;
}
.buttonVote {
  background-color: #01477b;
  border-radius: 0;
  padding: 11px 30px;
  margin-bottom: 8px;
  border-color: #01477b;
  margin-top: 20px;
}
.playerofMonth {
  font-size: 2rem;
  color: #01477b;
  font-weight: 400;
  padding-bottom: 20px;
}
::v-deep .cmApp_signupContainer #cmApp_signupForm label {
    text-align: left;
}
::v-deep .cmApp_signupContainer #cmApp_signupForm label {
    margin-left: 0;
}
::v-deep #cmApp_signupForm .cmApp_fieldWrap {
    margin: 16px 0 0 0;
}
::v-deep .cmApp_signupContainer div {
    padding: 0;
    margin: 6px 0 0;
    line-height: 1.1;
}
::v-deep .cmApp_signupContainer div.cmApp_errorMsg {
    display: none;
    color: red;
    text-align: left;
}
::v-deep .cmApp_signupContainer #cmApp_signupForm > div {
    padding: 0 6px;
}
::v-deep .cmApp_signupContainer input:not([type="radio"]):not([type="checkbox"]), .cmApp_signupContainer textarea, .cmApp_signupContainer select {
    background-color: #FFF;
    margin: 5px 0 0;
    width: 100%;
    font-size: 14px;
    height: 38px;
    border: 1px solid #d1d1d1;
    padding: 0.625em 0.4375em;
}
::v-deep .cmApp_signupContainer input:not([type="radio"]):not([type="checkbox"]), .cmApp_signupContainer textarea, .cmApp_signupContainer select {
    background-color: #FFF;
    margin: 5px 0 0;
    width: 100%;
    font-size: 14px;
    height: 38px;
    border: 1px solid #d1d1d1;
    padding: 0.625em 0.4375em;
}
::v-deep #cmApp_signupForm {
    text-align: left;
}
::v-deep .cmApp_signupContainer form {
    margin: 0;
    padding: 0;
}
::v-deep .cmApp_signupContainer.cmApp_embedded .cmApp_successMsg span {
    display: block;
    font-size: 12px;
}
::v-deep .cmApp_signupContainer.cmApp_embedded .cmApp_successMsg span:first-child {
    font-size: 18px;
    margin-bottom: 10px;
}
::v-deep .cmApp_signupContainer.cmApp_embedded .cmApp_successMsg {
    padding: 10px 20px 30px;
    margin-top: 0;
}
::v-deep .cmApp_signupContainer .cmApp_processingMsg, .cmApp_signupContainer .cmApp_successMsg {
    padding: 40px 20px;
    font-size: 16px;
    font-weight: normal;
    display: none;
    color: #000000;
}
::v-deep .cmApp_signupContainer .cmApp_processingMsg, .cmApp_signupContainer .cmApp_successMsg {
    padding: 40px 20px;
    font-size: 16px;
    font-weight: normal;
    display: none;
    color: #000000;
}
::v-deep .cmApp_signupContainer #cmApp_statusContainer.cmApp_hidden #cmApp_thankYouCheck {
    visibility: hidden;
    opacity: 0;
}
::v-deep .cmApp_signupContainer.cmApp_embedded #cmApp_thankYouCheck {
    width: 100%;
    box-sizing: border-box;
    opacity: 1;
    margin: 16px 0 0;
}
::v-deep .cmApp_signupContainer div {
    padding: 0;
    margin: 6px 0 0;
    line-height: 1.1;
}
::v-deep .cmApp_signupContainer {
    border: 1px solid #666;
    box-shadow: 1px 2px 2px;
    display: block;
    width: 80%;
    max-width: 400px;
    min-width: 200px;
    background-color: #FFF;
    /* padding: 25px 50px; */
    text-align: center;
    color: #000;
    z-index: 1999999999;
}
::v-deep .cmApp_signupContainer #cmApp_statusContainer {
    position: relative;
    white-space: nowrap;
    display: flex;
    margin: 5px 0 0;
}
::v-deep .cmApp_signupContainer #cmApp_statusContainer * {
    line-height: 1.1;
}
::v-deep .cmApp_signupContainer.cmApp_embedded #cmApp_statusContainer.cmApp_hidden {
    display: none;
}
::v-deep .cmApp_signupContainer.cmApp_embedded #cmApp_statusContainer {
    display: block;
}
::v-deep .cmApp_signupContainer #cmApp_statusContainer.cmApp_hidden {
    display: none;
}
::v-deep .cmApp_signupContainer #cmApp_statusContainer {
    position: relative;
    white-space: nowrap;
    display: flex;
    margin: 5px 0 0;
}
::v-deep #cmApp_signupContainer *, #signupFormPreviewCon *, .cmApp_signupContainer.cmApp_slideoutTab .cmApp_slideOutTab #cmApp_slideoutButton {
    /* font-family: 'Open Sans'; */
}
::v-deep .cmApp_signupContainer div {
    padding: 0;
    margin: 6px 0 0;
    line-height: 1.1;
}
::v-deep .cmApp_signupContainer input:not([type="radio"]):not([type="checkbox"]), .cmApp_signupContainer textarea, .cmApp_signupContainer select {
    background-color: #FFF;
    margin: 5px 0 0;
    width: 100%;
    font-size: 14px;
    height: 38px;
    border: 1px solid #d1d1d1;
    padding: 0.625em 0.4375em;
}
::v-deep .cmApp_signupFormWrapper {
    position: relative;
}
::v-deep .cmApp_signupContainer * {
    line-height: 1.6;
}
::v-deep .cmApp_signupContainer div {
    padding: 0;
    margin: 6px 0 0;
    line-height: 1.1;
}
::v-deep .cmApp_signupContainer {
    border: 1px solid #666;
    box-shadow: 1px 2px 2px;
    display: block;
    width: 100%;
    max-width: 400px;
    min-width: 200px;
    background-color: #FFF;
    /* padding: 25px 50px; */
    text-align: center;
    color: #000;
    z-index: 1999999999;
}
::v-deep .cmApp_signupContainer, .cmApp_signupContainer div, .cmApp_signupContainer input, .cmApp_signupContainer textarea, .cmApp_signupContainer select {
    box-sizing: border-box;
    font-size: 100%;
    font: inherit;
    /* line-height: 1.6; */
    vertical-align: baseline;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
::v-deep .cmApp_signupContainer.cmApp_embedded, .cmApp_signupContainer.cmApp_lightbox, .cmApp_signupContainer.cmApp_slideoutTab {
    max-width: 415px;
}
::v-deep .cmApp_signupContainer.cmApp_embedded {
    margin: 0 auto;
    box-shadow: none;
    background: transparent;
    border: none;
}
::v-deep #cmApp_modalBackground.cmApp_hidden {
    opacity: 0;
    display: none;
}
::v-deep #cmApp_modalBackground {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #000;
    opacity: .7;
    z-index: 1000000;
}
::v-deep .newsImage {
  width: 100%;
  padding-right: 5px;
  min-height: 233px;
}
.mobileMarginFeatured.featuredContact  {
  margin-top: 50px;
}
::v-deep .OOMSection.mobileMargin.oomMobileMargin {
  margin-top: 60px;
}
.adHeightHome {
  height: 125px;
}
::v-deep .gradSponsor {
  background-color: #D2682E;
  background-image: linear-gradient(to right, #ffb21c, #D2682E);
  height: 10px;
  width: 100%;
}
::v-deep .Greengrad {
  background-color: #98C556;
  background-image: linear-gradient(to right, #98C556 , #BCDD8D);
  height: 10px;
  width: 100%;
  margin-top: 0px;
}
article.card.DistCard.mobileDistCard > img{
  border-radius: 0!important;
}
.DistCard {
  border: 0px;
}
.mobileDistCard {
  border-radius: 0;
  border: 0px!important;
}
.mobileDistCard > .card-body {
  background-color: #042F62;
  color: #fff;;
}
.Post_WidgetSection {
  /* margin-bottom: 30px; */
  margin-bottom: 0px;
}
.NewsBTN {
  margin-bottom: 50px!important;
}
.GreyBack {
  padding-top: 50px;
  padding-bottom: 50px;
  background-image: url(https://assets.asiantour.com/asian-tour/2024/09/Latest-Images_Background.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
::v-deep .slider {
  padding-bottom: 0!important;
}
.homeButton {
  border-radius: 0px;
  width: 324px;
  height: 59px;
  font-weight: 500;
  color: #fff!important;
  line-height: 3.3;
  text-transform: uppercase;
  border: 0px;
  background-color: #D2682E;
  background-image: linear-gradient(#ffb21c, #D2682E);
  margin: auto;
  display: block;
  margin-top: 30px;
  font-size: 14px;
}
.homeButton:hover {
  border-radius: 0px;
  width: 324px;
  height: 59px;
  font-weight: 500;
  color: #fff!important;
  line-height: 3.3;
  text-transform: uppercase;
  border: 0px;
  background-color: #41a2f6!important;
  background-image: none;
  margin: auto;
  display: block;
  margin-top: 30px;
  font-size: 14px;
}
::v-deep iframe {
  width: 100%!important;
  height: 395px;
}
p.youtubeTitle {
  font-size: 16px;
  font-weight: 500;
  color: #0A3F7F;
  margin-top: 10px;
}
.VideoSection {
  padding-top: 50px;
  padding-bottom: 50px;
}
.YoutubeLink {
  width: 100%;
}
.SectionTitle {
  font-size: 23px;
  font-weight: 500;
  color: #042F62;
  padding-bottom: 25px;
}
.cardPad {
  /* width: 400px; */
  width: 450px;
}
.distButton {
  background-color: #98C556;
  border-radius: 0px;
  width: 279px;
  height: 58px;
  font-weight: 500;
  color: #fff!important;
  line-height: 2.8;
  text-transform: uppercase;
  border: 0px;
}
.distButton:hover {
  background-color: #41a2f6;
  border-radius: 0px;
  width: 279px;
  height: 58px;
  font-weight: 500;
  color: #fff!important;
  line-height: 2.8;
  text-transform: uppercase;
  border: 0px;
}
.distTitle {
  font-size: 23px;
  font-weight: 500;
  padding-bottom: 30px;
}
.distPara {
  font-size: 16px;
  font-weight: 300;
  padding-bottom: 20px;
}
::v-deep .distPara > p > strong {
  font-weight: 500;
}
.card.DistCard.flex-row > .card-body{
  background-color: #042F62;
  color: #fff;
  padding: 100px;
}
img.card-img-left {
  width: 50%;
}
img.imageReview {
  width: 100%;
}
.reviewSection.container {
  /* padding-top: 50px; */
  padding-bottom: 50px;
}
@media only screen and (max-width: 990px) {
  .cardPad {
    /* width: 400px; */
    width: auto;
  }
  ::v-deep .slider {
    padding-bottom: 0!important;
    /* margin-top: 110px; */
    margin-top: 10px;
  }
  .adHeightHome {
    height: auto!important;
  }
  .Post_WidgetSection {
    margin-bottom: 30px;
    margin-top: -50px;
  }
  .reviewSection.container {
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .firstReview {
    margin-bottom: 10px;
  }
  .reviewBlock {
    display: block;
  }
  .home {
    background-color: #fff;
    margin-top: 25px;
    overflow: hidden;
  }
  .card.DistCard.flex-row {
    display: inline-block;
  }
  img.card-img-left {
    width: 100%;
  }
  ::v-deep #upComing {
    padding-top: 15px!important;
    padding-bottom: 50px;
  }
  ::v-deep #gallery {
    padding-top: 30px!important;
    padding-bottom: 50px;
  }
  ::v-deep .card-img-top {
    width: 100%;
    height: auto;
    min-height: 183px;
    border-radius: 10px 10px 0 0 !important;
    max-height: 100%;
  }
  ::v-deep .homeFeaturedContent {
    max-width: 100% !important;
    margin-bottom: 2em !important;
  }
  .mobSocial {
    display: block;
    width: 100%;
    min-width: 100%;
  }
  ::v-deep .mobileMarginFeatured {
    margin-top: 0px;
  }
  ::v-deep .mobileMargin {
    margin-top: -4em;
  }
  ::v-deep .oomMobileMargin {
    margin-top: 0em;
  }
  ::v-deep .mobileMarginDest {
    margin-top: -60px;
  }
  ::v-deep iframe {
    width: 100%!important;
    height: 250px;
  }
  ::v-deep div#oomSlider {
    margin-top: 22em!important;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 1000px){
  ::v-deep .bkimage {
    background-repeat: no-repeat;
    background-size: cover;
    height: 500px!important;
    background-position: center;
  }
  ::v-deep div#oomSlider {
    margin-top: 7em!important;
  }
}
@media only screen and (max-width: 1024px) {
  .GreyBack {
    padding-top: 20px;
    padding-bottom: 30px;
    /* padding-bottom: 50px;
    background-image: url(https://assets.asiantour.com/asian-tour/2024/09/Latest-Images_Background.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover; */
  }
  .oomHeader {
    padding-bottom: 110px;
    padding-top: 30px;
  }
  .hidelatestNews {
    display: none;
  }
  ::v-deep .bkimage {
    background-repeat: no-repeat;
    background-size: cover;
    height: 800px;
    background-position: center;
  }
}
@media only screen and (max-width: 500px) {
  ::v-deep div#oomSlider {
    margin-top: 17em!important;
  }
}
@media only screen and (max-width: 425px) {
  .mobileCardPad {
    width: 350px;
  }
  div#ThreeNewsPics {
    display: none;
  }
  ::v-deep div#oomSlider {
    margin-top: 25em!important;
  }
}

::v-deep .carousel-control-prev {
  /* display: none; */
}
::v-deep .carousel-control-next {
  /* display: none; */
}
.instaLogo {
  max-width: 55px;
}
.socialTitle {
  font-size: 24px;
}
.home {
  background-color: #fff;
  margin-top: 25px;
}
#upComing {
  padding-top: 50px;
  padding-bottom: 50px;
}
#gallery {
  padding-top: 50px;
  padding-bottom: 50px;
}
#social {
  padding-bottom: 5%;
  margin-top: 2em;
}
::v-deep .nav-item {
  display: flex;
  align-items: center;
  padding-top: 7px;
}
::v-deep .col-md-10 {
  display: flex;
  align-items: center;
  padding-top: 7px;
}
::v-deep .fa-instagram {
  color: #cc4666;
}
.title {
  color: #133f7b;
}
.nav-link {
  display: block;
  padding: 0rem 0rem !important;
}
.mobSocial > h2 {
  padding-bottom: 20px;
}
@media only screen and (max-width: 768px) {
  .formSection {
    padding-top: 30px;
    background: white;
    padding: 0;
    font-size: 13pt;
    color: #00477c;
    padding-top: 30px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
  }
  .appImage {
    width: 100%;
    position: initial;
    margin-top: 0;
  }
  .home.container.nopadMod {
    padding: 0px;
    background-color: #fff;
  }
  .mobHide {
    display: none;
  }
  .mobShow {
    display: block;
  }
}
@media only screen and (max-width: 1400px) {
  .appImageLeft {
    display: none;
  }
  .appImage {
    width: 100%;
    position: inherit;
    right: 12em;
    margin-top: 0px;
  }
  .nocon {
    padding-left: 0;
    padding-right: 0;
    margin-left: 0px;
    margin-right: 0px;
  }
}
@media only screen and (min-width: 769px) {
  .deskHide{
    display: none;
  }
}
</style>
